import type { FC } from "react"
import React from "react"

import { AnimatePresence, motion } from "framer-motion"
import { atom } from "recoil"
import styled from "styled-components"

import { ReactComponent as ArrowIcon } from "@svg/arrow-left.svg"

const HideSidebarButton = styled.button<{
  isLeftSide: boolean
  isPanelOpen: boolean
}>`
  display: flex;
  flex-direction: ${({ isLeftSide }) => (isLeftSide ? `row` : `row-reverse`)};
  justify-content: ${({ isPanelOpen }) =>
    isPanelOpen ? `flex-start` : `center`};
  align-items: center;
  padding: 10px;
  gap: 10px;
  width: 100%;
  height: 50px;
  cursor: pointer;
  position: relative;
  flex-wrap: nowrap;
  background: #f7f7f8;
  p {
    white-space: nowrap;
    color: #8499b7;
    font-size: var(--step--1);
  }
`
const StyledArrow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 50%;
  flex-shrink: 0;
  width: 25px;
  height: 25px;
  box-shadow: 0px 0.5px 2px rgba(0, 0, 0, 0.35);
  svg {
    width: 12px;
    height: 12px;
    path {
      stroke: #516683;
    }
  }
`
const InnerIcon = styled(motion.div)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Label = styled(motion.p)`
  position: absolute;
  transform: translateY(-100%);
  writing-mode: vertical-rl;
  text-transform: capitalize;
  color: #8499b7;
  font-size: var(--step--1);
`

export const HidePanelButton: FC<{
  isPanelOpen: boolean
  setIsPanelOpen: React.Dispatch<React.SetStateAction<boolean>>
  isLeftSide: boolean
}> = ({ isLeftSide, setIsPanelOpen, isPanelOpen }) => {
  return (
    <HideSidebarButton
      isLeftSide={isLeftSide}
      isPanelOpen={isPanelOpen}
      onClick={() => setIsPanelOpen((prev) => !prev)}
      data-testid={isLeftSide ? `left` : `right` + `-close-side-panel-button`}
    >
      <Label
        animate={{
          opacity: isPanelOpen ? 0 : 1,
        }}
        transition={{
          duration: 0.15,
          delay: isPanelOpen ? 0 : 1,
        }}
      >
        {isLeftSide ? `phases` : `elements`}
      </Label>
      <StyledArrow>
        <InnerIcon
          animate={{
            rotate: isPanelOpen ? (isLeftSide ? 0 : 180) : isLeftSide ? 180 : 0,
          }}
          transition={{
            duration: 0.3,
          }}
        >
          <ArrowIcon />
        </InnerIcon>
      </StyledArrow>
      <AnimatePresence>
        {isPanelOpen && (
          <motion.p
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
              transition: {
                delay: 1,
                duration: 0.5,
              },
            }}
            exit={{
              opacity: 0,
              transition: {
                duration: 0,
              },
            }}
          >
            Hide Sidebar
          </motion.p>
        )}
      </AnimatePresence>
    </HideSidebarButton>
  )
}
